import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';

export default function BookDiscovery() {
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ full_name: '', contact_email: '', org_name: '', preferred_date: '', preferred_time: '' });
  const [status, setStatus] = useState('idle');

  // The smart close function
  const handleClose = () => {
    navigate(location.state?.from || '/');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    try {
      const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      await axios.post(`${baseURL}/api/leads/submit`, { ...form, request_type: 'Discovery Call' });
      setStatus('success');
    } catch (err) {
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4 text-center">
        <div className="bg-white p-8 rounded-xl shadow-lg max-w-md w-full">
          <div className="text-4xl mb-4">📅</div>
          <h2 className="text-2xl font-bold text-slate-900 mb-2">Request Received!</h2>
          <p className="text-slate-600 mb-6">Team will review your request and reach out shortly to confirm the calendar invite.</p>
          <button onClick={handleClose} className="bg-blue-600 text-white px-6 py-2 rounded-lg font-bold">Return</button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-blue-950 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-8 relative">
        <button onClick={handleClose} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600">✕</button>
        <h1 className="text-2xl font-bold text-slate-900 mb-1">Book a Discovery Call</h1>
        <p className="text-slate-500 mb-6 text-sm">Schedule a 20-minute consultation with our Fractional CAIO to discuss your AI strategy.</p>
        
        {status === 'error' && <div className="bg-red-50 text-red-600 p-3 rounded mb-4 text-sm">Error submitting request. Please try again.</div>}
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <input type="text" required placeholder="Full Name" className="w-full border p-2.5 rounded text-sm" value={form.full_name} onChange={e => setForm({...form, full_name: e.target.value})} />
          <input type="email" required placeholder="Work Email" className="w-full border p-2.5 rounded text-sm" value={form.contact_email} onChange={e => setForm({...form, contact_email: e.target.value})} />
          <input type="text" required placeholder="Organization" className="w-full border p-2.5 rounded text-sm" value={form.org_name} onChange={e => setForm({...form, org_name: e.target.value})} />
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-xs text-slate-500 mb-1 block">Preferred Date</label>
              <input type="date" required className="w-full border p-2.5 rounded text-sm" value={form.preferred_date} onChange={e => setForm({...form, preferred_date: e.target.value})} />
            </div>
            <div>
              <label className="text-xs text-slate-500 mb-1 block">Preferred Time</label>
              <select required className="w-full border p-2.5 rounded text-sm" value={form.preferred_time} onChange={e => setForm({...form, preferred_time: e.target.value})}>
                <option value="">-- Select Time --</option>
                <option value="Morning (9AM - 12PM)">Morning (9AM - 12PM)</option>
                <option value="Afternoon (1PM - 5PM)">Afternoon (1PM - 5PM)</option>
              </select>
            </div>
          </div>
          <button type="submit" className="w-full bg-blue-600 text-white font-bold py-3 rounded mt-4">{status === 'loading' ? 'Submitting...' : 'Request Time Slot'}</button>
        </form>
      </div>
    </div>
  );
}